module.exports = __webpack_public_path__ + "img/audio-messages-banner.dfb3fad6.png";